import template from './creditworthinessMobileHeader.html';
import controller from './creditworthinessMobileHeader.controller';
import './creditworthinessMobileHeader.scss';

let creditworthinessMobileHeaderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default creditworthinessMobileHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessMobileHeader/creditworthinessMobileHeader.component.js